import axios from "axios";

export const state = {
    canteens: [],
};

export const getters = {
    canteens: state => state.canteens,
};

export const mutations = {
    setCanteens(state, newValue) {
        state.canteens = newValue
    },
};

export const actions = {
    fetchCanteens({ commit }) {
        axios.get('/canteens').then(res => {
            commit('setCanteens', res.data.canteens);
        })
    },
};
